import { render, staticRenderFns } from "./VueBlocksContainer.vue?vue&type=template&id=038465b6&scoped=true&"
import script from "./VueBlocksContainer.vue?vue&type=script&lang=js&"
export * from "./VueBlocksContainer.vue?vue&type=script&lang=js&"
import style0 from "./VueBlocksContainer.vue?vue&type=style&index=0&id=038465b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038465b6",
  null
  
)

export default component.exports